var map = {
	"./isotipo_producto_amarillo.png": "./src/components/MultiApp/assetsHome/isotipo_producto_amarillo.png",
	"./isotipo_producto_azul.png": "./src/components/MultiApp/assetsHome/isotipo_producto_azul.png",
	"./isotipo_producto_blanco.png": "./src/components/MultiApp/assetsHome/isotipo_producto_blanco.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/components/MultiApp/assetsHome sync recursive ^\\.\\/isotipo_producto_.*\\.png$";